export default function StartPage() {
  const steps = [
    { step: '下载注册', desc: '从官网或官方应用商店下载APP，使用手机号或邮箱创建账户，设置登录密码。' },
    { step: '身份认证', desc: '根据平台要求提交身份信息完成实名认证，认证后账户功能更完整。' },
    { step: '资产充值', desc: '在钱包页面选择充值的币种，将数字资产转入或用法币购买。' },
    { step: '了解市场', desc: '浏览交易页面，查看币种行情、K线图走势和市场深度信息。' },
    { step: '尝试下单', desc: '选择交易对，输入数量和价格，提交第一笔限价或市价单。' },
    { step: '提取资产', desc: '完成交易后可将资产提现至个人钱包，提现前设置安全验证并核对地址。' },
  ]

  return (
    <div className="pt-24 pb-20" data-page-container>
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6"><span className="gradient-text">易欧新手入门教程</span></h1>
          <p className="text-muted text-lg leading-relaxed max-w-3xl">
            按以下步骤完成首次数字资产交易的完整流程。
          </p>
        </div>

        <div className="relative" data-unique-module="beginner-quickstart">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-gradient-to-b from-accent via-accent-2 to-transparent" />
          <div className="space-y-10">
            {steps.map((item, i) => (
              <div key={i} className="flex items-start gap-6">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent to-accent-2 text-white flex items-center justify-center shrink-0 text-sm font-bold font-mono relative z-10 shadow-lg shadow-accent/30">
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div className="cyber-card p-6 flex-1">
                  <h2 className="text-lg font-semibold text-cyber-text mb-2">{item.step}</h2>
                  <p className="text-muted text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 p-6 cyber-card">
          <p className="text-muted text-sm">建议在熟悉基础操作后阅读平台使用指南，了解更多高级功能和交易策略。</p>
        </div>
      </div>
    </div>
  )
}
